<section
  id="compliance"
  class="p-8 sm:p-10 md:p-12 rounded-3xl bg-neutral-2 border border-neutral-3 space-y-8"
>
  <div class="max-w-3xl space-y-3">
    <div
      class="inline-flex items-center gap-2 px-3 py-1 rounded-md text-xs font-semibold bg-amber-a3 text-amber-11 border border-amber-5 w-fit"
    >
      <mat-icon svgIcon="shield-check" class="w-4! h-4! text-base! text-amber-11!" />
      <span>Conformité réglementaire</span>
    </div>

    <h2 class="text-2xl sm:text-3xl font-extrabold text-neutral-12 tracking-tight">
      Éthique professionnelle et loi Hoguet
    </h2>

    <p class="text-sm sm:text-base text-neutral-10 leading-relaxed">
      @if (audience() === 'pro') {
        En France, la transaction immobilière est une profession strictement réglementée. ETXE est conçue pour
        valoriser l’expertise et l’habilitation légale des titulaires d’une carte T ou d’une attestation CCI,
        dans le respect intégral de la déontologie.
      } @else {
        En France, la transaction immobilière est une profession réglementée. ETXE est conçue pour respecter
        100 % du cadre légal et valoriser la compétence des titulaires d’une carte T active.
      }
    </p>
  </div>

  <!-- Highlight Interactive Carte T Block -->
  <div
    class="rounded-2xl border border-neutral-3 bg-card p-6 sm:p-8 md:p-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center"
  >
    <div class="lg:col-span-6 space-y-4">
      <span
        class="inline-flex items-center gap-x-1.5 rounded-md bg-primary-a3 px-2.5 py-1 text-xs font-bold text-primary-11 border border-primary-a4"
      >
        Garantie ETXE • Professionnels certifiés
      </span>

      <h3 class="text-xl sm:text-2xl font-bold text-neutral-12">
        Carte professionnelle (carte T) vérifiée à la source
      </h3>

      <p class="text-sm text-neutral-10 leading-relaxed">
        @if (audience() === 'pro') {
          Sur ETXE, vous ne subissez aucune concurrence déloyale de profils non habilités. Tous les
          professionnels inscrits — qu’ils soient agents d’agence, mandataires de réseau ou conseillers
          indépendants — justifient d’une carte T valide ou d’une attestation collaborateur vérifiée auprès de
          la CCI.
        } @else {
          Seuls les professionnels qualifiés — qu’ils soient agents d’agence, mandataires de réseau ou
          conseillers indépendants — titulaires d’une carte T valide et vérifiée auprès de la CCI peuvent
          soumettre leurs candidatures.
        }
      </p>

      <ul class="space-y-2.5 pt-2">
        <li class="flex items-center gap-x-3 text-xs text-neutral-12 font-medium">
          <span
            class="flex size-5 items-center justify-center rounded-full bg-jade-a3 text-jade-11 font-bold text-[10px]"
          >
            ✓
          </span>
          <span>Authentification officielle délivrée par la Chambre de Commerce et d’Industrie (CCI)</span>
        </li>
        <li class="flex items-center gap-x-3 text-xs text-neutral-12 font-medium">
          <span
            class="flex size-5 items-center justify-center rounded-full bg-jade-a3 text-jade-11 font-bold text-[10px]"
          >
            ✓
          </span>
          <span>Vérification active des mentions Transaction et Assurance RCP obligatoire</span>
        </li>
        <li class="flex items-center gap-x-3 text-xs text-neutral-12 font-medium">
          <span
            class="flex size-5 items-center justify-center rounded-full bg-jade-a3 text-jade-11 font-bold text-[10px]"
          >
            ✓
          </span>
          @if (audience() === 'pro') {
            <span
              >Valorisation de votre professionnalisme face aux plateformes généralistes non
              réglementées</span
            >
          } @else {
            <span>Protection des propriétaires contre le démarchage sauvage et non qualifié</span>
          }
        </li>
      </ul>
    </div>

    <div class="lg:col-span-6 flex flex-col items-center">
      <div class="w-full max-w-sm">
        <etxe-agent-card-display [card]="sampleCard" />
      </div>
      <span
        class="mt-4 text-[11px] text-neutral-10 italic flex items-center gap-x-1.5 bg-neutral-1 px-3 py-1.5 rounded-md border border-neutral-3"
      >
        <span>💡</span>
        <span>Données de carte professionnelle fictives (démonstration)</span>
      </span>
    </div>
  </div>

  <!-- 3 Pillars Cards -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div class="p-6 rounded-2xl bg-card border border-neutral-3 flex flex-col gap-3">
      <div class="flex size-10 items-center justify-center rounded-lg bg-amber-a3 text-amber-11">
        <mat-icon svgIcon="shield-alert" class="w-5! h-5!" />
      </div>
      <h3 class="text-base font-bold text-neutral-12">Indépendance des parties</h3>
      <p class="text-xs sm:text-sm text-neutral-10 leading-relaxed">
        ETXE n’intervient jamais dans la négociation ni la transaction. Vendeurs et agents concluent leurs
        mandats en toute liberté et autonomie contractuelle.
      </p>
    </div>

    <div class="p-6 rounded-2xl bg-card border border-neutral-3 flex flex-col gap-3">
      <div class="flex size-10 items-center justify-center rounded-lg bg-amber-a3 text-amber-11">
        <mat-icon svgIcon="coins" class="w-5! h-5!" />
      </div>
      <h3 class="text-base font-bold text-neutral-12">Plateforme sans commission</h3>
      <p class="text-xs sm:text-sm text-neutral-10 leading-relaxed">
        Nous ne prélevons aucun pourcentage sur les transactions. ETXE fonctionne comme un outil SaaS d’aide à
        la prospection pour les professionnels certifiés.
      </p>
    </div>

    <div class="p-6 rounded-2xl bg-card border border-neutral-3 flex flex-col gap-3">
      <div class="flex size-10 items-center justify-center rounded-lg bg-amber-a3 text-amber-11">
        <mat-icon svgIcon="file-text" class="w-5! h-5!" />
      </div>
      <h3 class="text-base font-bold text-neutral-12">Conformité loi Hoguet</h3>
      <p class="text-xs sm:text-sm text-neutral-10 leading-relaxed">
        Les échanges respectent la confidentialité des coordonnées des vendeurs et facilitent l’établissement
        du mandat préalable réglementaire.
      </p>
    </div>
  </div>
</section>
